var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.getHideIcons)?_c('v-icon',_vm._g(_vm._b({},'v-icon',_vm.$attrs,false),{ ..._vm.$listeners }),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }